import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import "@arco-design/web-react/es/_util/react-19-adapter";
import "@arco-design/web-react/dist/css/arco.css";

import { createAppProviders } from "./app/providers";
import { buildAppRouter } from "./app/router";
import { initOtel } from "./lib/observability/otel";

const providers = createAppProviders();
const router = buildAppRouter();
const rootElement = document.getElementById("root");
initOtel();

if (!rootElement) {
  throw new Error("Missing #root element in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={providers.queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
